
<button
  id="uploadFileModalBtn"
  data-toggle="modal"
  data-target="#uploadFileModal"
  [hidden]="true">
  Upload File Modal
</button>
<!--START MODAL ADD-->
<div id="uploadFileModal" class="modal fade" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content bd-0 bg-transparent overflow-hidden">
      <div class="modal-body p-0">
        <div class="row no-gutters">
          <div class="col-12">
            <div class="modal-box modal-form-modern p-3">
              <div class="file-modal-header">
                <h5 class="file-modal-header__title">
                  @if (EOTA_Authorities && EOTA_Authorities.authorities && EOTA_Authorities.authorities.includes('WRITE') && fileUploadType!=null) {
                    <button
                      type="button"
                      class="file-header-btn file-header-btn--inline"
                      ngbTooltip="Select Type" placement="left"
                      (click)="onTypeSelect(null)">
                      <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    </button>
                  }
                  @if (fileUploadType==null) {
                    <span>New File Upload</span>
                  }
                  @if (fileUploadType=='device' && !otaeditfile) {
                    <span>Device File Upload</span>
                  }
                  @if (fileUploadType=='device' && otaeditfile) {
                    <span>Device File Edit</span>
                  }
                  @if (fileUploadType=='ecu') {
                    <span>ECU OTA File Upload</span>
                  }
                </h5>
                <div class="file-modal-header__actions">
                  @if (!otaeditfile) {
                    <button type="button" class="file-header-btn" id="closeModal" #closeModal
                      (click)="closeOTAFileUploadModal()" aria-label="Close">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  }
                  @if (otaeditfile) {
                    <button type="button" class="file-header-btn" id="closeModal" #closeModal
                      data-dismiss="modal" (click)="cancelModal()" aria-label="Close">
                      <i class="fa fa-times" aria-hidden="true"></i>
                    </button>
                  }
                </div>
              </div>
              <!-- Type Selection Start -->
              @if (fileUploadType==null) {
                <div class="file-type-grid">
                  <button type="button" class="file-type-card" (click)="onTypeSelect('device')">
                    <span class="file-type-card__icon"><i class="fa fa-microchip" aria-hidden="true"></i></span>
                    <span class="file-type-card__title">Device OTA File</span>
                    <span class="file-type-card__desc">Upload device firmware, configuration, package, or SDK files.</span>
                  </button>
                  @if (EOTA_Authorities && EOTA_Authorities.authorities && EOTA_Authorities.authorities.includes('WRITE')) {
                    <button type="button" class="file-type-card" (click)="onTypeSelect('ecu')">
                      <span class="file-type-card__icon"><i class="fa fa-hdd-o" aria-hidden="true"></i></span>
                      <span class="file-type-card__title">ECU OTA File</span>
                      <span class="file-type-card__desc">Upload Electronic Control Unit base or calibration files.</span>
                    </button>
                  }
                </div>
              }
              <!-- Type Selection End -->
              <!-- Form Start -->
              @if (fileUploadType!=null) {
                <div class="login-content">
                  <!-- Device File Form Start -->
                  @if (fileUploadType==='device') {
                    <form
                      action="javascript:void(0);"
                      novalidate
                      #f="ngForm"
                      method="POST"
                      class="margin-bottom-0">
                      <div class="scrollable-modal-body add-file-modal">
                        @for (divData of dataSource; track divData; let i = $index) {
                          <div class="file-upload-block">
                            <div class="row mb-2">
                              <div class="col-md-6 sm-form-design mb-2">
                                <label class="control-label dm-field__label">File Type <span class="text-danger">*</span></label>
                                <div class="file-dd">
                                  <app-button-dropdown
                                    leadIcon="fa fa-file-o"
                                    [options]="deviceFileTypeOptions"
                                    [selectedValue]="columns[i]['otaType']"
                                    placeholder="Select File Type"
                                    minWidth="100%"
                                    minHeight="42px"
                                    accentColor="#009BCB"
                                    [disabled]="otaeditfile || isOtaPartner"
                                    [searchable]="true"
                                    searchPlaceholder="Search file type…"
                                    menuMaxHeight="220px"
                                    (selectionChange)="onDeviceFileTypeSelect($event, i)">
                                  </app-button-dropdown>
                                </div>
                                <input type="hidden" name="otaType{{i}}" [(ngModel)]="columns[i]['otaType']" #otaType="ngModel" required />
                                <div [hidden]="otaType.valid || (otaType.pristine && !f.submitted)">
                                  <small class="text-danger">Please select file type</small>
                                </div>
                              </div>
                              @if (!otaeditfile) {
                                <div class="col-md-6 sm-form-design mb-2">
                                  <label class="control-label dm-field__label">Select File <span class="text-danger">*</span></label>
                                  <div class="file-picker-row">
                                    <input
                                      required
                                      #inputFile
                                      name="file{{i}}"
                                      type="file"
                                      class="file-picker-input"
                                      autocomplete="off"
                                      [accept]="columns[i].fileExtension"
                                      (change)="getUploadedFile(inputFile, i)"
                                    />
                                    <button type="button" class="file-picker-btn" (click)="inputFile.click()">
                                      Choose File
                                    </button>
                                    <span class="file-picker-name" [class.is-empty]="!columns[i]['fileName']">
                                      {{ getSelectedFileLabel(i) }}
                                    </span>
                                    <button
                                      type="button"
                                      class="deleteRow-btn"
                                      [class.is-visible]="i != 0"
                                      ngbTooltip="Remove File"
                                      placement="top"
                                      (click)="deleteRow(i)"
                                      [attr.aria-label]="'Remove file ' + (i + 1)">
                                      <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                  </div>
                                  @if (attachedFile && !columns[i]['fileName']) {
                                    <div>
                                      <small class="text-danger">Please attach file</small>
                                    </div>
                                  }
                                </div>
                              }
                              <div class="col-md-6 sm-form-design mb-2">
                                <label class="control-label dm-field__label">File Name <span class="text-danger">*</span></label>
                                <input
                                  #fileName{{i}}
                                  type="text"
                                  class="form-control h5-email"
                                  name="newFolderName{{i}}"
                                  id="newFolderName{{i}}"
                                  autocomplete="off"
                                  tabindex="2"
                                  placeholder="Enter file name"
                                  #newFolderName="ngModel"
                                  [disabled]="otaeditfile"
                                  [(ngModel)]="columns[i]['newFolderName']"
                                  (keydown)="$event.keyCode != 32 ? $event:$event.preventDefault()"
                                  required>
                                <div [hidden]="newFolderName.valid || (newFolderName.pristine && !f.submitted) || otaeditfile">
                                  <small class="text-danger">Please enter File Name</small>
                                </div>
                              </div>
                              <div class="col-md-6 sm-form-design mb-2">
                                <label class="control-label dm-field__label">Expected File Version</label>
                                <input
                                  type="text"
                                  class="form-control h5-email"
                                  name="fileVersion{{i}}"
                                  id="fileVersion{{i}}"
                                  autocomplete="off"
                                  tabindex="2"
                                  placeholder="Enter expected file version"
                                  #fileVersion="ngModel"
                                  [disabled]="otaeditfile"
                                  [(ngModel)]="columns[i]['fileVersion']"
                                  (keydown)="$event.keyCode != 32 ? $event:$event.preventDefault()">
                              </div>
                              <div class="col-md-12 sm-form-design">
                                <label class="control-label dm-field__label">Description</label>
                                <textarea
                                  class="form-control h5-email"
                                  name="DescrName{{i}}"
                                  id="DescrName{{i}}"
                                  autocomplete="off"
                                  placeholder="Enter description"
                                  #DescrName="ngModel"
                                  rows="3"
                                  cols="50"
                                  maxlength="100"
                                  (keyup)="onKeyPress($event)"
                                  [(ngModel)]="columns[i]['DescrName']"></textarea>
                              </div>
                            </div>
                            @if (i < dataSource.length - 1) {
                              <hr class="file-block-divider">
                            }
                          </div>
                        }
                      </div>
                      @if (dataSource.length < 5 && !otaeditfile) {
                        <div class="text-right mt-3 mb-2">
                          <button
                            class="btn btn-outline-primary"
                            type="button"
                            (click)="addRow()">
                            <i class="fa fa-plus-circle"></i> Add More Files
                          </button>
                        </div>
                      }
                      <div class="login-buttons width100 text-right">
                        @if (!otaeditfile) {
                          <button class="btn btn-outline-secondary small-screen-btn mr-2"
                            (click)="closeModal(f)">Cancel
                          </button>
                        }
                        @if (otaeditfile) {
                          <button
                            class="btn btn-outline-secondary alertBtn small-screen-btn mr-2"
                            (click)="cancelModal()" type="button">
                            Cancel
                          </button>
                        }
                        <button type="button" id="close-modal" data-dismiss="modal"
                          style="display: none">Close
                        </button>
                        @if (!otaeditfile) {
                          <button
                            class="btn small-screen-btn btn-success"
                            [disabled]="disable" (click)="uploadMultiFiles(f.valid, f)" type="button">
                            Upload
                          </button>
                        }
                        @if (otaeditfile) {
                          <button
                            class="btn small-screen-btn btn-success"
                            [disabled]="disable"
                            (click)="uploadMultiFiles(f.valid, f)"
                            type="button">
                            Save
                          </button>
                        }
                      </div>
                      <div class="row mt-3">
                        <div class="col-12">
                          @if (incrimentBy) {
                            <div class="progress">
                              <div
                                class="progress-bar"
                                [ngbTooltip]="uploadProgress + '% uploaded successfully' "
                                placement="top"
                                [style.width]="uploadProgress + '%'"
                                role="progressbar"
                                aria-valuenow="0"
                                aria-valuemin="0"
                                aria-valuemax="100">
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </form>
                  }
                  <!-- Device File Form End -->
                  <!-- ECU OTA Form Start -->
                  @if (fileUploadType==='ecu') {
                    <form
                      action="javascript:void(0);"
                      novalidate
                      #ecuForm="ngForm"
                      (ngSubmit)="uploadMultiFiles(ecuForm.valid, ecuForm)"
                      method="POST"
                      class="margin-bottom-0">
                      <div class="scrollable-modal-body add-file-modal">
                        @for (divData of dataSource; track divData; let i = $index) {
                          <div class="file-upload-block">
                            <div class="row mb-2">
                              <div class="col-md-4 sm-form-design mb-2">
                                <label class="control-label dm-field__label">File Type <span class="text-danger">*</span></label>
                                <div class="file-dd">
                                  <app-button-dropdown
                                    leadIcon="fa fa-file-o"
                                    [options]="ecuFileTypeOptions"
                                    [selectedValue]="columns[i]['otaType']"
                                    placeholder="Select File Type"
                                    minWidth="100%"
                                    minHeight="42px"
                                    accentColor="#009BCB"
                                    [searchable]="true"
                                    searchPlaceholder="Search file type…"
                                    menuMaxHeight="220px"
                                    (selectionChange)="onEcuFileTypeSelect($event, i)">
                                  </app-button-dropdown>
                                </div>
                                <input type="hidden" name="otaType{{i}}" [(ngModel)]="columns[i]['otaType']" #otaType="ngModel" required />
                                <div [hidden]="otaType.valid || (otaType.pristine && !ecuForm.submitted)">
                                  <small class="text-danger">Please select file type</small>
                                </div>
                              </div>
                              <div class="col-md-4 sm-form-design mb-2">
                                <label class="control-label dm-field__label">ECU Group <span class="text-danger">*</span></label>
                                <div class="file-dd">
                                  <app-button-dropdown
                                    leadIcon="fa fa-cubes"
                                    [options]="getEcuGroupOptions(i)"
                                    [selectedValue]="columns[i]['selectedEcuGroup']"
                                    placeholder="Select ECU Group"
                                    minWidth="100%"
                                    minHeight="42px"
                                    accentColor="#009BCB"
                                    [searchable]="true"
                                    searchPlaceholder="Search ECU group…"
                                    menuMaxHeight="220px"
                                    (selectionChange)="onEcuGroupSelect($event, i)">
                                  </app-button-dropdown>
                                </div>
                                <input type="hidden" name="ecuGroup{{i}}" [(ngModel)]="columns[i]['selectedEcuGroup']" #ecuGroup="ngModel" required />
                                <div [hidden]="ecuGroup.valid || (ecuGroup.pristine && !ecuForm.submitted)">
                                  <small class="text-danger">Please select Ecu Group.</small>
                                </div>
                              </div>
                              <div class="col-md-4 sm-form-design mb-2">
                                <label class="control-label dm-field__label">ECU Name <span class="text-danger">*</span></label>
                                <div class="file-dd">
                                  <app-button-dropdown
                                    leadIcon="fa fa-microchip"
                                    [options]="getEcuNameOptions(i)"
                                    [selectedValue]="columns[i]['selectedEcuName']"
                                    placeholder="Select ECU Name"
                                    minWidth="100%"
                                    minHeight="42px"
                                    accentColor="#009BCB"
                                    [searchable]="true"
                                    searchPlaceholder="Search ECU name…"
                                    menuMaxHeight="220px"
                                    (selectionChange)="onEcuNameSelect($event, i)">
                                  </app-button-dropdown>
                                </div>
                                <input type="hidden" name="ecuName{{i}}" [(ngModel)]="columns[i]['selectedEcuName']" #ecuName="ngModel" required />
                                <div [hidden]="ecuName.valid || (ecuName.pristine && !ecuForm.submitted)">
                                  <small class="text-danger">Please select Ecu Name.</small>
                                </div>
                              </div>
                              <div class="col-md-6 sm-form-design mb-2">
                                <label class="control-label dm-field__label">File Name <span class="text-danger">*</span></label>
                                <input
                                  #eotaFileName{{i}}
                                  type="text"
                                  class="form-control h5-email"
                                  name="newFolderName{{i}}"
                                  id="newFolderName{{i}}"
                                  autocomplete="off"
                                  tabindex="2"
                                  placeholder="Enter file name"
                                  #newFolderName="ngModel"
                                  [(ngModel)]="columns[i]['newFolderName']"
                                  (keydown)="$event.keyCode != 32 ? $event:$event.preventDefault()"
                                  required>
                                <div [hidden]="newFolderName.valid || (newFolderName.pristine && !ecuForm.submitted)">
                                  <small class="text-danger">Please enter File Name</small>
                                </div>
                              </div>
                              <div class="col-md-6 sm-form-design mb-2">
                                <label class="control-label dm-field__label">Select File <span class="text-danger">*</span></label>
                                <div class="file-picker-row">
                                  <input
                                    required
                                    #inputFile
                                    name="file{{i}}"
                                    type="file"
                                    class="file-picker-input"
                                    autocomplete="off"
                                    [accept]="columns[i].fileExtension"
                                    (change)="getUploadedFile(inputFile, i)"
                                  />
                                  <button type="button" class="file-picker-btn" (click)="inputFile.click()">
                                    Choose File
                                  </button>
                                  <span class="file-picker-name" [class.is-empty]="!columns[i]['fileName']">
                                    {{ getSelectedFileLabel(i) }}
                                  </span>
                                  <button
                                    type="button"
                                    class="deleteRow-btn"
                                    [class.is-visible]="i != 0"
                                    ngbTooltip="Remove File"
                                    placement="top"
                                    (click)="deleteRow(i)"
                                    [attr.aria-label]="'Remove file ' + (i + 1)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                  </button>
                                </div>
                                @if (attachedFile && !columns[i]['fileName']) {
                                  <div>
                                    <small class="text-danger">Please attach file</small>
                                  </div>
                                }
                              </div>
                            </div>
                            @if (i < dataSource.length - 1) {
                              <hr class="file-block-divider">
                            }
                          </div>
                        }
                      </div>
                      @if (dataSource.length < 5) {
                        <div class="text-right mt-3 mb-2">
                          <button
                            class="btn btn-outline-primary"
                            type="button"
                            (click)="addRow()">
                            <i class="fa fa-plus-circle"></i> Add More Files
                          </button>
                        </div>
                      }
                      <div class="login-buttons width100 text-right">
                        <button class="btn btn-outline-secondary small-screen-btn mr-2" type="button"
                          data-dismiss="modal">Cancel
                        </button>
                        <button
                          class="btn small-screen-btn btn-success"
                          [disabled]="disable"
                          type="submit">
                          Upload
                        </button>
                      </div>
                      <div class="row mt-3">
                        <div class="col-12">
                          @if (incrimentBy) {
                            <div class="progress">
                              <div
                                class="progress-bar"
                                [ngbTooltip]="uploadProgress + '% uploaded successfully' "
                                placement="top"
                                [style.width]="uploadProgress + '%'"
                                role="progressbar"
                                aria-valuenow="0"
                                aria-valuemin="0"
                                aria-valuemax="100">
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </form>
                  }
                  <!-- ECU OTA Form End -->
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--END MODAL ADD -->
